import React from 'react';
import styled from 'styled-components';
import SymbolFormat from './SymbolFormat';
import { toSlug } from '../../../../lib/utils';
import { DATA_TRACK_TYPE_CTA, DATA_TRACK_CLICK_NOTIFICATION_SECTION } from '../../../../lib/constants';
import Button from '../Button/Button';

const NotificationContainer = styled.div`
  color: ${p => p.theme.c.text.primary};
  display: flex;
  align-items: center;
  justify-content: center;

  .content-section--notification {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    h2 {
      ${({ theme }) => theme.typographyRebrand.heading['2xl']}
      margin-bottom: 8px;
    }
    p {
      ${({ theme }) => theme.typographyRebrand.body.lg}
      text-align: center;
    }
    button, a {
      margin-top: 24px;
    }
    @media screen and (max-width: ${p => p.theme.breakpoint.mobile}px) {
      h2 {
        text-align: center;
      }
    }
  }
`;

const NotificationSection = (props) => {
  const {
    title,
    subtitle,
    buttonUrl,
    buttonText
  } = props;

  return (
    <NotificationContainer>
      <div className="content-section content-section--notification">
        <SymbolFormat elementTag="h2" text={title} />
        <SymbolFormat linebreaks text={subtitle} />
        <Button
          variant="primary"
          size="medium"
          url={buttonUrl}
          buttonText={buttonText}
          data-track-id={toSlug(buttonText)}
          data-track-click={DATA_TRACK_CLICK_NOTIFICATION_SECTION}
          data-track-type={DATA_TRACK_TYPE_CTA}
        />
      </div>
    </NotificationContainer>
  );
};

export default NotificationSection;
